import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  ${display}
  ${space}
  ${layout}
  filter: drop-shadow( 2px 2px 12px rgba(0,0,0,1) );
`;

const RightArrowSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="right-arrow-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="100%"
        height="100%"
        viewBox="0 0 26 43"
        data-testid="right-arrow-svg"
      >
        <defs>
          <path
            id="prefix__a"
            d="M10.59-6.645L8.847-4.962a.994.994 0 000 1.442L24.77 11.872 8.846 27.265a.994.994 0 000 1.442l1.745 1.683a1.085 1.085 0 001.495 0l18.453-17.796a.995.995 0 000-1.443L12.086-6.645a1.085 1.085 0 00-1.495 0z"
          ></path>
        </defs>
        <g fill="none" fillRule="evenodd" transform="rotate(90 12 13)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a"></use>
          </mask>
          <use
            fill="#FFF"
            fillRule="nonzero"
            transform="rotate(-90 19.692 11.872)"
            xlinkHref="#prefix__a"
          ></use>
        </g>
      </svg>
    </StyledContainer>
  );
};

export default RightArrowSVG;
